module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('header-back', {
    attrs: {
      "title": _vm.getTitle,
      "canBack": true,
      "onBack": _vm.goBack,
      "isCross": _vm.isCross
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.actualPage === _vm.pageList.existUBO) ? _c('div', {
    staticClass: "w-100 style25Exist"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.does_pp_25_exist')) + "\n      "), _c('div', {
    staticClass: "row no-gutter my-4"
  }, [_c('div', {
    staticClass: "text-center m-0 selectionBloc",
    class: {
      selectionBlocActive: _vm.moreThan25percentEmployee === 'yes'
    },
    on: {
      "click": function($event) {
        _vm.moreThan25percentEmployee = 'yes'
      }
    }
  }, [_c('label', {
    staticClass: "m-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('iframe_page.yes')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center m-0 selectionBloc",
    class: {
      selectionBlocActive: _vm.moreThan25percentEmployee === 'no'
    },
    on: {
      "click": function($event) {
        _vm.moreThan25percentEmployee = 'no'
      }
    }
  }, [_c('label', {
    staticClass: "m-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('iframe_page.no')) + "\n          ")])])]), _vm._v(" "), (_vm.moreThan25percentEmployee === 'yes') ? _c('div', [_c('button', {
    staticClass: "validation-btn btn-next",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.actualPage = _vm.pageList.nbrUBO
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.next')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.moreThan25percentEmployee === 'no') ? _c('div', [_c('label', {
    staticClass: "information_check_no"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('iframe_page.check_informations_2')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 no-gutter"
  }, [_c('button', {
    staticClass: "validation-btn btn-next",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.actualPage = _vm.pageList.warningUBO
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.transmit_declaration')) + "\n            ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.actualPage === _vm.pageList.nbrUBO) ? _c('div', {
    staticClass: "row no-gutter"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.number_shareholder')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.availableMoreThan25PersonNumber), function(availableNumber) {
    return _c('div', {
      staticClass: "col-2 p-0"
    }, [(!_vm.hiddenNbrUBO_2) ? _c('div', {
      staticClass: "selectionBloc w-100",
      class: {
        selectionBlocActive: _vm.numberOfMoreThan25 === availableNumber
      },
      on: {
        "click": function($event) {
          _vm.numberOfMoreThan25 = availableNumber
        }
      }
    }, [_vm._v("\n          " + _vm._s(availableNumber) + "\n        ")]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "validation-btn btn-next mt-4",
    attrs: {
      "disabled": !_vm.numberOfMoreThan25,
      "type": "button"
    },
    on: {
      "click": _vm.btnValidateUboNbr
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.next')) + "\n      ")])], 2) : _vm._e(), _vm._v(" "), (_vm.actualPage === _vm.pageList.UBODetails) ? _c('div', [_c('shareholder', {
    key: _vm.actualShareholder,
    attrs: {
      "shareholderNumber": _vm.actualShareholder,
      "shareholderMaxNumber": _vm.numberOfMoreThan25
    },
    on: {
      "input": _vm.refreshShareholderList
    },
    model: {
      value: (_vm.shareholderList[_vm.actualShareholder - 1]),
      callback: function($$v) {
        _vm.$set(_vm.shareholderList, _vm.actualShareholder - 1, $$v)
      },
      expression: "shareholderList[actualShareholder - 1]"
    }
  }), _vm._v(" "), (_vm.showWarning) ? _c('small', [_vm._v(_vm._s(_vm.$t('iframe_page.mandatory_field')))]) : _vm._e(), _vm._v(" "), (!_vm.isLastShareholder) ? _c('button', {
    staticClass: "validation-btn btn-next",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextShareHolder()
      }
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('common.next')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isLastShareholder) ? _c('button', {
    staticClass: "validation-btn btn-next",
    staticStyle: {
      "margin-top": "6%"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isActiveBtnTransmited
    },
    on: {
      "click": _vm.saveShareHolder
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('common.transmit_declaration')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isLastShareholder) ? _c('button', {
    staticClass: "styleSaveDeclaration",
    on: {
      "click": function($event) {
        return _vm.saveDraftShareholder()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.save_declaration')) + "\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualPage === _vm.pageList.warningUBO) ? _c('div', [_c('svg', {
    staticClass: "pos-svg",
    attrs: {
      "width": "95",
      "height": "94",
      "viewBox": "0 0 95 94",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M92.6651 76.5066L56.7628 6.14165C55.8123 4.28334 54.4085 2.73211 52.6992 1.65128C50.9899 0.570444 49.0383 0 47.05 0C45.0617 0 43.1101 0.570444 41.4008 1.65128C39.6915 2.73211 38.2877 4.28334 37.3372 6.14165L1.39802 76.5066C0.457353 78.3032 -0.0243427 80.3308 0.00094687 82.3873C0.0262364 84.4437 0.557628 86.4572 1.54215 88.227C2.52668 89.9968 3.92995 91.4612 5.61209 92.474C7.29423 93.4869 9.19649 94.013 11.1292 93.9998H82.9339C84.8508 94.0016 86.7352 93.4732 88.4023 92.4664C90.0695 91.4596 91.462 90.0089 92.4433 88.2568C93.4246 86.5046 93.961 84.511 93.9999 82.4717C94.0388 80.4324 93.5788 78.4174 92.6651 76.6243V76.5066ZM41.5393 29.3019C41.5393 27.7416 42.1218 26.2451 43.1587 25.1418C44.1957 24.0384 45.602 23.4186 47.0684 23.4186C48.5348 23.4186 49.9412 24.0384 50.9781 25.1418C52.015 26.2451 52.5975 27.7416 52.5975 29.3019V42.8141V56.3262C52.5975 57.8865 52.015 59.383 50.9781 60.4863C49.9412 61.5897 48.5348 62.2095 47.0684 62.2095C45.602 62.2095 44.1957 61.5897 43.1587 60.4863C42.1218 59.383 41.5393 57.8865 41.5393 56.3262V42.8141V29.3019ZM47.2159 82.2914C45.9619 82.2914 44.7361 81.8957 43.6935 81.1544C42.6509 80.4131 41.8383 79.3595 41.3584 78.1268C40.8786 76.8941 40.753 75.5376 40.9976 74.229C41.2423 72.9203 41.8461 71.7183 42.7328 70.7748C43.6194 69.8313 44.7491 69.1888 45.979 68.9285C47.2088 68.6682 48.4836 68.8018 49.6421 69.3124C50.8006 69.823 51.7908 70.6877 52.4874 71.7971C53.1841 72.9065 53.5559 74.2108 53.5559 75.5451C53.5559 77.3343 52.8879 79.0503 51.6989 80.3154C50.5099 81.5806 48.8973 82.2914 47.2159 82.2914Z",
      "fill": "#49A0A2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "styleSpan"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.shareholder_error'))), _c('br'), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('iframe_page.need_help'))), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('iframe_page.contact_service'))), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('iframe_page.service_client')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-next mt-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.actualPage = _vm.pageList.nbrUBO
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.declare_shareholder')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 text-center mt-4"
  }, [_c('label', {
    staticClass: "styleSaveDeclaration"
  }, [_vm._v(" " + _vm._s(_vm.$t('iframe_page.plus_shareholder')) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.actualPage === _vm.pageList.UBOSaved) ? _c('div', [_c('svg', {
    staticClass: "pos-svg-2",
    attrs: {
      "width": "102",
      "height": "102",
      "viewBox": "0 0 102 102",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0 51C0 22.8329 22.8341 0 51 0C79.1659 0 102 22.8329 102 51C102 79.1671 79.1659 102 51 102C22.8341 102 0 79.1671 0 51ZM63.3177 38.447C65.1282 36.6377 68.0641 36.6377 69.8746 38.447C71.6875 40.2587 71.6851 43.1935 69.8735 45.004L50.2037 64.6738C48.3932 66.4843 45.4561 66.4843 43.6456 64.6738L33.8118 54.8412C32.0013 53.0295 32.0013 50.0936 33.8118 48.2831C35.6235 46.4726 38.5583 46.4726 40.3688 48.2831L46.9258 54.84L63.3177 38.447Z",
      "fill": "#49A0A2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "styleSpan",
    staticStyle: {
      "margin-top": "-5%"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('iframe_page.thanks')))]), _vm._v(" "), _c('p', {
    staticClass: "styleSpan"
  }, [_vm._v(" " + _vm._s(_vm.$t('iframe_page.declaration_transmited')))]), _vm._v(" "), _c('p', {
    staticClass: "styleSpan"
  }, [_vm._v(" " + _vm._s(_vm.$t('iframe_page.declaration_transmited_2')))]), _vm._v(" "), _c('button', {
    staticClass: "validation-btn style-btn-document",
    staticStyle: {
      "margin-bottom": "10%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.handler_document')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "validation-btn style-btn-chantier"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.find_chantier')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualPage === _vm.pageList.UBODraftSaved) ? _c('div', [_c('svg', {
    staticClass: "pos-svg",
    attrs: {
      "width": "102",
      "height": "102",
      "viewBox": "0 0 102 102",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0 51C0 22.8329 22.8341 0 51 0C79.1659 0 102 22.8329 102 51C102 79.1671 79.1659 102 51 102C22.8341 102 0 79.1671 0 51ZM63.3177 38.447C65.1282 36.6377 68.0641 36.6377 69.8746 38.447C71.6875 40.2587 71.6851 43.1935 69.8735 45.004L50.2037 64.6738C48.3932 66.4843 45.4561 66.4843 43.6456 64.6738L33.8118 54.8412C32.0013 53.0295 32.0013 50.0936 33.8118 48.2831C35.6235 46.4726 38.5583 46.4726 40.3688 48.2831L46.9258 54.84L63.3177 38.447Z",
      "fill": "#49A0A2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "styleSpan"
  }, [_vm._v(" " + _vm._s(_vm.$t('iframe_page.declaration_saved')))]), _vm._v(" "), _c('p', {
    staticClass: "styleSpan"
  }, [_vm._v(" " + _vm._s(_vm.$t('iframe_page.declaration_saved_2')))]), _vm._v(" "), _c('button', {
    staticClass: "validation-btn style-btn-document",
    staticStyle: {
      "margin-bottom": "10%"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.handler_document')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "validation-btn style-btn-chantier"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.find_chantier')) + "\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3452e93c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3452e93c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/DocumentUboView.vue
// module id = 2327
// module chunks = 2